
import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { UserDropdown } from "./UserDropdown";
import { useAuth } from "@/hooks/useAuth";

interface Props { scrolled?: boolean; }

export function DesktopNavigation({ scrolled = true }: Props) {
  const { user } = useAuth();
  const linkClass = `text-sm font-semibold font-primary transition-colors duration-200 ${
    scrolled ? "text-gray-700 hover:text-brand-primary" : "text-white/85 hover:text-white"
  }`;

  return (
    <>
      <Link to="/sobre" className={linkClass}>Quem Somos</Link>

      <NavigationMenu>
        <NavigationMenuList className="gap-0">
          <NavigationMenuItem>
            <NavigationMenuTrigger className={`bg-transparent border-none p-0 h-auto font-primary text-sm font-semibold transition-colors duration-200 ${
              scrolled ? "text-gray-700 hover:text-brand-primary" : "text-white/85 hover:text-white"
            }`}>
              Serviços
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid gap-1 p-3 w-72">
                {[
                  { to: "/servicos", label: "Todos os Serviços" },
                  { to: "/servicos#servicos", label: "Pessoa Física" },
                  { to: "/servicos#servicos", label: "Pessoa Jurídica" },
                  { to: "/servicos#servicos", label: "Voluntário" },
                ].map((item) => (
                  <li key={item.label}>
                    <Link to={item.to} className="block rounded-lg p-3 text-sm font-semibold font-primary text-gray-700 hover:bg-brand-primary/5 hover:text-brand-primary transition-colors">
                      {item.label}
                    </Link>
                  </li>
                ))}
                <li className="border-t border-gray-100 mt-1 pt-1">
                  <Link to="/servicos#faq" className="block rounded-lg p-3 text-sm font-semibold font-primary text-brand-accent hover:bg-brand-accent/5 transition-colors">
                    Dúvidas Frequentes
                  </Link>
                </li>
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>

      <Link to="/avaliacoes" className={linkClass}>Agendamento</Link>
      <Link to="/consultorios" className={linkClass}>Depoimentos</Link>
      <span className={`text-sm font-semibold font-primary opacity-30 cursor-not-allowed`} title="Em breve">Loja</span>
      <span className={`text-sm font-semibold font-primary opacity-30 cursor-not-allowed`} title="Em breve">Blog</span>
      <Link to="/contato" className={linkClass}>Contato</Link>

      {user ? (
        <UserDropdown />
      ) : (
        <Link
          to="/logins"
          className={`text-sm font-bold font-primary px-5 py-2.5 rounded-full border-2 transition-all duration-200 ${
            scrolled
              ? "border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white"
              : "border-white/40 text-white hover:bg-white/10"
          }`}
        >
          Área do Paciente
        </Link>
      )}
    </>
  );
}
